/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1InsideprintingsQueryResponse } from '../../types/GetV1Insideprintings.ts'

export const getV1InsideprintingsQueryKey = () => [{ url: '/v1/InsidePrintings' }] as const

export type GetV1InsideprintingsQueryKey = ReturnType<typeof getV1InsideprintingsQueryKey>

/**
 * {@link /v1/InsidePrintings}
 */
export async function getV1Insideprintings(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1InsideprintingsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/InsidePrintings`, ...requestConfig })
    return res
}

export function getV1InsideprintingsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1InsideprintingsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1InsideprintingsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1InsideprintingsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Insideprintings(config)
        },
    })
}

/**
 * {@link /v1/InsidePrintings}
 */
export function useGetV1Insideprintings<
    TData = ResponseConfig<GetV1InsideprintingsQueryResponse>,
    TQueryData = ResponseConfig<GetV1InsideprintingsQueryResponse>,
    TQueryKey extends QueryKey = GetV1InsideprintingsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1InsideprintingsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1InsideprintingsQueryKey()

    const query = useQuery(
        {
            ...getV1InsideprintingsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
